import { required } from "vuelidate/lib/validators";

export default class UNData {
  nome = "";
  sigla = "";
  id = null;
  conversor = 0;
  tipo_conversor = 0;
  unidade_tributavel = null;

  constructor({
    nome = "",
    sigla = "",
    id = null,
    conversor = 0,
    tipo_conversor = 0,
    unidade_tributavel = null,
  }) {
    this.nome = nome;
    this.sigla = sigla;
    this.id = id;
    this.conversor = conversor;
    this.tipo_conversor = tipo_conversor;
    this.unidade_tributavel = unidade_tributavel;
  }
}

export const UNDataRequired = {
  nome: {
    required,
  },
  sigla: {
    required,
  },
};
